/**
 * @fileoverview Shared analytics cookie names (edge + client safe).
 * @module lib/analytics/cookie-names
 */

/** Middleware region flag — `1` = EEA/UK/CH default-deny regions. */
export { REGION_CONSENT_REQUIRED_COOKIE } from "./region"

/** Server-set first-party attribution persistence (Safari ITP). */
export const ATTRIBUTION_COOKIE_NAME = "adsights_attr_v1"

/** localStorage key for persisted first/last acquisition touch. */
export const ATTRIBUTION_STORAGE_KEY = "adsights_attribution_v1"

/** sessionStorage key for in-session nav pair (internal referral). */
export const ATTRIBUTION_NAV_KEY = "adsights_nav_path_v1"

/** Edge-readable analytics opt-in mirror (`1` granted, `0` denied). */
export const CONSENT_ANALYTICS_MIRROR_COOKIE = "adsights_consent_analytics"

/** Edge-readable explicit analytics opt-in (`1` only after user save/accept). */
export const CONSENT_ANALYTICS_EXPLICIT_COOKIE = "adsights_consent_explicit"

/** ~400-day max-age for first-party analytics cookies. */
export const ANALYTICS_COOKIE_MAX_AGE_SEC = 400 * 24 * 60 * 60

/** Alias used by attribution cookie modules. */
export const ATTRIBUTION_COOKIE_MAX_AGE_SEC = ANALYTICS_COOKIE_MAX_AGE_SEC
